// Vue and Vuex
import Vue from "vue";
import Vuex from "vuex";                               // Global App State
import i18n from "@/plugins/i18n";                     // Global internationalization plug-in
import createPersistedState from "vuex-persistedstate"; // Get persistence (page-reload safe)

// Modules
import AppState from "./modules/AppState";
import UserState from "./modules/UserState";
import ChatbotState from "./modules/ChatbotState";
import FileInputState from "./modules/FileInputState";
import RadarState from "./modules/RadarState";

Vue.use(Vuex);

// Vue-persisted state makes vuex persistent over the time (until user delete the browser data), using LocalStorage API.
// LocalStorage has limit to 10 MB, so we choose to save only user important data and the app settings.
// TODO - check the  ['AppState', 'UserState'] informations
let persistedStateOptions = {
    paths: ['AppState', 'UserState'],
};

export default new Vuex.Store({
    plugins: [createPersistedState(persistedStateOptions)],
    modules: {
        AppState,
        UserState,
        ChatbotState,
        FileInputState,
        RadarState
    },
});
